import React from "react";
import {
  Grid,
  createStyles,
  makeStyles,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";

import { Formik } from "formik";
import * as Yup from "yup";

import { POST_INSERT_PROJECT_TYPE } from "../../../services/options";
import { useSnackbar } from "notistack";
import api from "../../../services/Api";
import { ButtonSuccess } from "../../../Components/ButtonSuccess";
import DefaultModal, {
  DefaultModalActions,
  DefaultModalContent,
} from "../../../Components/DefaultModal";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "grid",
      [theme.breakpoints.up("xs")]: {
        width: 380,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("sm")]: {
        width: 450,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("md")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("lg")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("xl")]: {
        width: 550,
        padding: theme.spacing(0, 1, 0, 1),
      },
    },
  })
);

const initialValues = {
  type: "",
  medicao: 0,
};

const validationSchema = Yup.object().shape({
  type: Yup.string().required("Obrigatório"),
  medicao: Yup.number().required("Obrigatório"),
});

export default function NewProjectType({ open, setOpen, updateData }) {
  const { enqueueSnackbar } = useSnackbar();

  const submit = async (values, { setSubmitting }) => {
    const buffer = {
      tipo: values.type,
      medicao: values.medicao === 1 ? true : false,
    };
    await api(POST_INSERT_PROJECT_TYPE(buffer))
      .then((r) => {
        const { data } = r;
        if (data.status === "success") {
          updateData();
          setSubmitting(false);
          enqueueSnackbar("Tipo de projeto criado com sucesso", {
            variant: "success",
          });
          setOpen(false);
        } else {
          setSubmitting(false);
          enqueueSnackbar("Erro ao criar tipo de projeto", {
            variant: "error",
          });
        }
      })
      .catch((e) => {
        setSubmitting(false);
        enqueueSnackbar(`Erro ${e.message}`, { variant: "error" });
      });
  };

  return (
    <DefaultModal
      open={open}
      handleClose={() => setOpen()}
      title="Novo tipo de projeto"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={submit}
      >
        {(props) => <Forms {...props} />}
      </Formik>
    </DefaultModal>
  );
}

const Forms = (props) => {
  const classes = useStyles();
  const {
    values,
    touched,
    errors,
    isSubmitting,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = props;

  return (
    <form onSubmit={handleSubmit} noValidate>
      <DefaultModalContent dividers>
        <Grid container className={classes.root} spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              maxRows={5}
              variant="outlined"
              size="small"
              id="type"
              label="Tipo"
              name="type"
              autoFocus
              inputProps={{ autoComplete: "off" }}
              onChange={handleChange}
              value={values.type}
              error={touched.type && Boolean(errors.type)}
              helperText={touched.type && errors.type}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Medição</FormLabel>
              <RadioGroup
                aria-label="medicao"
                name="medicao"
                id="medicao"
                value={values.medicao}
                onChange={(e, value) => {
                  setFieldValue("medicao", Number(value));
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel value={1} control={<Radio />} label="Sim" />
                  <FormControlLabel value={0} control={<Radio />} label="Não" />
                </div>
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </DefaultModalContent>
      <DefaultModalActions style={{ marginRight: "0.5rem" }}>
        <ButtonSuccess
          style={{ width: 120 }}
          variant="contained"
          color="primary"
          type="submit"
          success={false}
          loading={isSubmitting}
        >
          {" "}
          Criar
        </ButtonSuccess>
      </DefaultModalActions>
    </form>
  );
};
